import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Grid,
  Typography,
  Modal
} from '@mui/material';
import { useMediaQuery, useTheme } from '@mui/material';
import { Intro } from './Intro';
import { Collaborators } from './Collaborators';
import backgroundImage from './background.svg';
import { COLOR_DENIM, COLOR_HUMMINGBIRD } from 'popTheme';
import { defineMessages, useIntl } from 'react-intl';
import { SignIn } from 'components/form/SignIn';
import Register from 'components/form/Register';
import LanguageToggle from "components/landing/LanguageToggle";

export const Landing = ({ isRegister = false, component }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery('(max-width: 600px)');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(isMobile && isRegister);
  }, [isMobile, isRegister]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const intl = useIntl();
  const messages = defineMessages({
    landingMobileLogIn: {
      id: 'landing.login',
      defaultMessage: 'Log In',
      description: 'Button text for mobile landing page log in',
    },
  });

  return (
    // We want a grid here according to the design.  There is a top section and a bottom section.
    // Top part 2/3 of the height.
    //      The right part of the top is 1/3 of the size.  The left part is 2/3
    // Bottom part 1/3 of the height
    //      The bottom section will fill width.
    <Grid
      container
      direction={'column'}
      wrap={'nowrap'}
      sx={{
        backgroundImage: `url(${backgroundImage})`,
        height: '100%',
        [theme.breakpoints.up('sm')]: {
          minWidth: '1920px',
        },
      }}
    >
      <Box
        xs={1}
        position="absolute"
        display={{ sm: 'none' }}
        sx={{
            textAlign: 'right',
            top: '3rem',
            width: '100%',
        }}
      >
          <Grid container justifyContent="space-between" direction="row" sx={{ px:'1rem'  }} >
              {isMobile && <Grid item data-testid="small-screen-language-toggle">
                  <Grid container justifyContent="left">
                      <LanguageToggle/>
                  </Grid>
              </Grid>}
              <Grid item>
              <Button
                  variant="contained"
                  onClick={handleOpen}
                  disableElevation
                  disableRipple
                  sx={{
                      backgroundColor: COLOR_DENIM,
                      borderRadius: '0.375rem',
                      height: '2.25rem',
                      width: '4.875rem',
                      px: '0.5rem',
                      py: '1.25rem',
                  }}
              >
                  <Typography variant="subtitle1" sx={{ fontWeight: 600, color: COLOR_HUMMINGBIRD }}>
                      {intl.formatMessage(messages.landingMobileLogIn)}
                  </Typography>
              </Button>
              <Modal open={open} onClose={handleClose}>
                  <Box
                      sx={{
                          position: 'absolute',
                          minWidth: '23rem',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                      }}
                  >
                      {!isRegister ? <SignIn handleClose={handleClose} /> : <Register />}
                  </Box>
              </Modal>
              </Grid>
          </Grid>
      </Box>
      <Grid
        item
        xs={8}
        sx={{
          [theme.breakpoints.only('xs')]: {
            pt: '5.625rem',
          },
          [theme.breakpoints.up('sm')]: {
            p: '5.625rem',
          },
        }}
      >
        <Grid container direction="row">
          <Grid item xs={12} sm={8}>
            <Intro />
          </Grid>
          <Grid item sm={4} sx={{ display: { xs: 'none', sm: 'block' } }}>
            {!isMobile && <Grid container direction="column" rowSpacing="3.75rem">
              <Grid item>
                <Grid container justifyContent="right">
                  <LanguageToggle/>
                </Grid>
              </Grid>
              <Grid item>{component}</Grid>
            </Grid>}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={4}>
        <Collaborators />
      </Grid>
    </Grid>
  );
};
